import src from "IMAGE";
export default { src, width: 574, height: 647, blurWidth: 0, blurHeight: 0};
